import React, { useEffect, useState } from "react";
import "./EnterMobileNumber.css";
import { useDispatch } from "react-redux";
import { setActiveComponent } from "../../../Redux/Slices/activeComponentSlice";
import { generateMobileOtp, verifyPhoneNumber } from "../../../api/auth";
import Loader from "../../Loader";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function EnterMobileNumber({ mode = "signup" }) {
  const [phone, setPhone] = useState("");
  const [countryData, setCountryData] = useState(null);
  const [errorTooltip, setErrorTooltip] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [referralCode, setReferralCode] = useState("");
  const [agreed, setAgreed] = useState(false);
  const [isReferralLocked, setIsReferralLocked] = useState(false);
  const dispatch = useDispatch();

  const handleChange = (value, country) => {
    setPhone(value);
    setCountryData(country);
    if (errorTooltip) setErrorTooltip("");
  };

  // Prefill referral code from URL if present; otherwise honor persisted lock/code
  useEffect(() => {
    try {
      const search = window.location.search || "";
      const urlParams = new URLSearchParams(search);
      const urlCode =
        urlParams.get("referralcode")

      if (urlCode) {
        setReferralCode(urlCode);
        setIsReferralLocked(true);
        localStorage.setItem("refreeAffiliateCode", urlCode);
        localStorage.setItem("referralCode", urlCode);
        localStorage.setItem("isReferralLocked", "true");
      } else {
        // restore any previously validated/locked code from storage
        const locked = localStorage.getItem("isReferralLocked") === "true";
        const saved = localStorage.getItem("refreeAffiliateCode") || localStorage.getItem("referralCode");
        if (saved) setReferralCode(saved);
        setIsReferralLocked(!!locked);
      }
    } catch (e) { }
  }, []);

  const handleContinueClick = async () => {
    if (isLoading) return;

    const purePhoneNumber = phone.replace(/\D/g, "");

    if (!purePhoneNumber || purePhoneNumber.length < 10) {
      setErrorTooltip("Enter valid phone number");
      return;
    }

    setIsLoading(true);
    try {
      const verifyResult = await verifyPhoneNumber(
        countryData.dialCode,
        purePhoneNumber.slice(-10)
      );

      console.log("Check PhoneNumber response:", verifyResult);

      if (verifyResult?.success && verifyResult?.statusCode === 200) {
        const otpResult = await generateMobileOtp(purePhoneNumber);

        console.log("Generate OTP response:", otpResult);

        if (otpResult?.success && otpResult?.statusCode === 200) {
          localStorage.setItem("countryCode", countryData.dialCode);
          localStorage.setItem("phoneNumber", purePhoneNumber.slice(-10));

          // persist referral for next step
          if (referralCode) {
            localStorage.setItem("refreeAffiliateCode", referralCode);
          }
          dispatch(setActiveComponent("mobileOtpVerification"));
        } else {
          setErrorTooltip(otpResult?.message || "Failed to send OTP");
        }
      } else if (verifyResult?.statusCode === 409) {
        setErrorTooltip(
          verifyResult.message || "Phone number already registered"
        );
      } else if (verifyResult?.statusCode === 400) {
        setErrorTooltip(verifyResult?.message || "Invalid phone number");
      } else {
        setErrorTooltip(
          verifyResult?.message || "Phone Number Verification Failed"
        );
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Phone Number Verification Failed";
      setErrorTooltip(message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleContinueClick();
    }
  };

  return (
    <div className="CreateNewAccount">
      <div className="createNewAccountContainer">
        <h1 className="getStartedText">Create New Account</h1>
        <p className="signInText2">Create a new account with us</p>
        <div className="generalInputContainer">
          <label htmlFor="phoneInput" className="labelText">
            Phone Number
          </label>
          <div className="phoneNumberInputContainer">
            <PhoneInput
              className="phoneInput"
              containerClass="containerClass"
              country={"ca"}
              value={phone}
              onChange={handleChange}
              enableSearch
              searchPlaceholder="Search country or code..."
              searchNotFound="No country found"
              inputProps={{
                name: "phone",
                required: true,
                autoFocus: true,
                onKeyDown: handleKeyDown,
                placeholder: "Enter your phone number",
                "aria-label": "Phone number input",
                "aria-describedby": errorTooltip ? "phone-error" : undefined,
                "aria-expanded": "false",
                "aria-haspopup": "listbox",
              }}
              inputStyle={{
                width: "100%",
                paddingLeft: "70px",
              }}
              containerStyle={{
                width: "100%",
                position: "relative",
              }}
              buttonStyle={{
                width: "58px",
              }}
              dropdownStyle={{
                width: "100%",
                maxHeight: "290px",
              }}
              searchStyle={{
                width: "100%",
              }}
              buttonClass="custom-flag-button"
              searchClass="search-dark"
              dropdownClass="country-dropdown"
              countryListProps={{
                role: "listbox",
                "aria-label": "Country selection",
              }}
            />
            {errorTooltip && (
              <span
                className="errorTooltip"
                id="phone-error"
                role="alert"
                aria-live="polite"
              >
                {errorTooltip}
              </span>
            )}
          </div>
        </div>
        <div className="generalInputContainer" style={{ marginTop: "12px", width: "100%" }}>
          <label htmlFor="referralInput" className="labelText">
            Referral Code (optional)
          </label>
          <input
            id="referralInput"
            type="text"
            value={referralCode}
            onChange={(e) => {
              setReferralCode(e.target.value.trim());
              localStorage.setItem("refreeAffiliateCode", e.target.value.trim());
            }}
            disabled={isReferralLocked}
            placeholder="Enter referral code"
            style={{
              width: "100%",
              height: "56px",
              borderRadius: "12px",
              border: "2px solid #333",
              background: "linear-gradient(135deg, #1A1A1A 0%, #2A2A2A 100%)",
              color: "white",
              padding: "0 16px",
              fontSize: "16px",
              boxSizing: "border-box",
            }}
            aria-label="Referral code input"
          />
        </div>

        {/* Agreement */}
        <div className="checkboxContainer">
          <input type="checkbox" checked={agreed} onChange={() => setAgreed(!agreed)} />
          <label className="checkboxLabel">
            By signing up you agree to the terms of use and privacy policy
          </label>
        </div>

        <button
          className="btnContainer"
          onClick={handleContinueClick}
          disabled={isLoading}
          aria-label={
            isLoading ? "Processing..." : "Continue with phone number"
          }
        >
          {isLoading ? <Loader /> : <span className="btnText">Continue</span>}
        </button>
      </div>
    </div>
  );
}

export default EnterMobileNumber;
